<template>
  <div :class="{'flex justify-end' : isJustifiedToRight}">
    <CustomLink
      :text="$t('Learn more')"
      :url="link"
      :type="LINK_TYPE.Primary"
    />
  </div>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'LearnMore',

  props: {
    link: {
      type: String,
      required: true,
    },
    isJustifiedToRight: {
      type: Boolean,
      default: true,
    },
  },
  setup() {

    return { LINK_TYPE };
  
  },
});

</script>
